export const formatCustomerName = ({ first_name, last_name }) => {
  return [first_name, last_name].filter(Boolean).join(' ')
}
